
import { defineComponent } from 'vue';
import VButton from '@/components/vendor/basic/button/VButton.vue';
import VModal from '@/components/vendor/modal/VModal.vue';
import ModalHeader from '@/components/vendor/modal/ModalHeader.vue';
import ModalTitle from '@/components/vendor/modal/ModalTitle.vue';
import ModalBody from '@/components/vendor/modal/ModalBody.vue';
import ModalFooter from '@/components/vendor/modal/ModalFooter.vue';
import useCapabilities from '@/resources/capabilities';
import { mapState } from 'vuex';

export default defineComponent({
  name: 'ThePatientPurchaseAuthorizationShow',
  components: {
    ModalFooter,
    ModalBody,
    ModalTitle,
    ModalHeader,
    VModal,
    VButton,
  },
  setup() {
    return {
      ...useCapabilities(),
    };
  },
  computed: {
    ...mapState('patient/expedient/purchaseAuthorization', ['currentPurchaseAuthorization']),
    ...mapState('app', ['formsSettings']),
  },
  methods: {
    closeModal() {
      this.$emit('closed');
    },
    status() {
      // eslint-disable-next-line max-len
      const type = this.formsSettings.purchase_authorization_statuses.find((o) => o.key === this.currentPurchaseAuthorization?.status);

      return type.label;
    },
  },
});
